module.exports = __webpack_public_path__ + "static/media/snowboard-hero.f0839ec8.jpg";